import axios from "axios";
import http from "../ http-common";
import store  from "../store";

const getApibaseurl = () => {
  const state = store.getState();
 // console.log("user suer  ",state.server?.API_BASE_URL );
  return state.server?.API_BASE_URL 
};



class UserService {
  static headers() {
    return {
      headers: {
        // withCredentials: false,
        Authorization: `Bearer ${window.localStorage.token || ""}`,
      },
    };
  }

  static getAll(page, limit, filter = {}) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/users`, {
      params: {
        page,
        limit,
        ...filter,
      },
    });
  }

  static get(id) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/users/${id}`);
  }

  static create(data) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return axios.post(`${API_BASE_URL}/users`, data);
  }

  static update(id, form) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return axios.put(`${API_BASE_URL}/users/${id}`, form, this.headers());
  }

  static delete(id) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.delete(`${API_BASE_URL}/users/${id}`);
  }

  static deleteAll() {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.delete(`${API_BASE_URL}/users`);
  }

  static toggleStatus(id, attribute) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/users/${id}/toggle_status/${attribute}`);
  }

  static getFolder(id) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/users/folder/${id}`);
  }

  static acceptDocument(id) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/document/accept/${id}`);
  }

  static refuseDocument(id) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/document/refuse/${id}`);
  }

  static updateDocumentExpireAt(documentId, date) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.put(`${API_BASE_URL}/documents/${documentId}`, { expire_at: date });
  }
}

export default UserService;

